import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useThemeComponents } from '../../../themes';

const InventorySuccessModal = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('inventoryDetails');
    const { Modal } = useThemeComponents();
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <Modal
                afterClose={actions.close}
                onCancel={actions.close}
                onOk={() => navigate(`/admin/inventories`)}
                open={visible}
            >
                {t('inventoryDetails:messages.addInventory.success')}
            </Modal>
        ),
    };
};

export default InventorySuccessModal;
